import { GbgrundbuchgeschaeftService, GrundbuchgeschaeftSearchRequestEgbtbidMeta } from '../../../../core/gb-api';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { submit } from '../grundbuchgeschaeft.functions';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { AutofocusDirective } from '../../../../shared/directives/autofocus.directive';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundbuchgeschaeft-suche-egbtbid',
  templateUrl: './grundbuchgeschaeft-suche-egbtbid.component.html',
  styleUrls: ['./grundbuchgeschaeft-suche-egbtbid.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    AutofocusDirective,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class GrundbuchgeschaeftSucheEgbtbidComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  egbtbid: GrundbuchgeschaeftSearchRequestEgbtbidMeta;

  @ViewChild('form', { static: false })
  form: NgForm;

  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private grundbuchgeschaeftService: GbgrundbuchgeschaeftService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.grundbuchgeschaeftService.searchGbGeschaeftEgbtbidTemplate().subscribe((template) => {
      this.egbtbid = this.copyLastRequest(template, SearchMode.searchFachId);
    });
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.egbtbid;
    submit(this.form, SearchMode.searchFachId, this.egbtbid, this.router, this.route);
  }

  onReset(EGBTBID): void {
    this.form.reset();
    this.subscription = this.grundbuchgeschaeftService.searchGbGeschaeftEgbtbidTemplate().subscribe((template) => {
      this.egbtbid = template;
      EGBTBID.focus();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
